import * as React from 'react'

export const CPU = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0447 0C19.4757 0 19.0144 0.461289 19.0144 1.03031V9.82133C19.0144 10.3904 19.4757 10.8516 20.0447 10.8516C20.6137 10.8516 21.075 10.3904 21.075 9.82133V1.03031C21.075 0.461289 20.6137 0 20.0447 0Z"
      fill="#254447"
    />
    <path
      d="M27.5225 0C26.9535 0 26.4922 0.461289 26.4922 1.03031V9.82133C26.4922 10.3904 26.9535 10.8516 27.5225 10.8516C28.0915 10.8516 28.5528 10.3904 28.5528 9.82133V1.03031C28.5528 0.461289 28.0915 0 27.5225 0Z"
      fill="#254447"
    />
    <path
      d="M35 0C34.431 0 33.9697 0.461289 33.9697 1.03031V9.82133C33.9697 10.3904 34.431 10.8516 35 10.8516C35.5691 10.8516 36.0304 10.3904 36.0304 9.82133V1.03031C36.0304 0.461289 35.5691 0 35 0Z"
      fill="#254447"
    />
    <path
      d="M42.4776 0C41.9086 0 41.4473 0.461289 41.4473 1.03031V9.82133C41.4473 10.3904 41.9086 10.8516 42.4776 10.8516C43.0466 10.8516 43.5079 10.3904 43.5079 9.82133V1.03031C43.5079 0.461289 43.0466 0 42.4776 0Z"
      fill="#254447"
    />
    <path
      d="M49.9554 0C49.3863 0 48.925 0.461289 48.925 1.03031V9.82133C48.925 10.3904 49.3863 10.8516 49.9554 10.8516C50.5244 10.8516 50.9857 10.3904 50.9857 9.82133V1.03031C50.9857 0.461289 50.5244 0 49.9554 0Z"
      fill="#254447"
    />
    <path
      d="M20.0447 59.1484C19.4757 59.1484 19.0144 59.6097 19.0144 60.1788V68.9698C19.0144 69.5388 19.4757 70.0001 20.0447 70.0001C20.6137 70.0001 21.075 69.5388 21.075 68.9698V60.1788C21.075 59.6097 20.6137 59.1484 20.0447 59.1484Z"
      fill="#254447"
    />
    <path
      d="M27.5225 59.1484C26.9535 59.1484 26.4922 59.6097 26.4922 60.1788V68.9698C26.4922 69.5388 26.9535 70.0001 27.5225 70.0001C28.0915 70.0001 28.5528 69.5388 28.5528 68.9698V60.1788C28.5528 59.6097 28.0915 59.1484 27.5225 59.1484Z"
      fill="#254447"
    />
    <path
      d="M35 59.1484C34.431 59.1484 33.9697 59.6097 33.9697 60.1788V68.9698C33.9697 69.5388 34.431 70.0001 35 70.0001C35.5691 70.0001 36.0304 69.5388 36.0304 68.9698V60.1788C36.0304 59.6097 35.5691 59.1484 35 59.1484Z"
      fill="#254447"
    />
    <path
      d="M42.4776 59.1484C41.9086 59.1484 41.4473 59.6097 41.4473 60.1788V68.9698C41.4473 69.5388 41.9086 70.0001 42.4776 70.0001C43.0466 70.0001 43.5079 69.5388 43.5079 68.9698V60.1788C43.5079 59.6097 43.0466 59.1484 42.4776 59.1484Z"
      fill="#254447"
    />
    <path
      d="M49.9554 59.1484C49.3863 59.1484 48.925 59.6097 48.925 60.1788V68.9698C48.925 69.5388 49.3863 70.0001 49.9554 70.0001C50.5244 70.0001 50.9857 69.5388 50.9857 68.9698V60.1788C50.9857 59.6097 50.5244 59.1484 49.9554 59.1484Z"
      fill="#254447"
    />
    <path
      d="M60.1788 21.0743H68.9698C69.5388 21.0743 70.0001 20.613 70.0001 20.044C70.0001 19.475 69.5388 19.0137 68.9698 19.0137H60.1788C59.6097 19.0137 59.1484 19.475 59.1484 20.044C59.1484 20.613 59.6097 21.0743 60.1788 21.0743Z"
      fill="#254447"
    />
    <path
      d="M68.9698 26.4922H60.1788C59.6097 26.4922 59.1484 26.9535 59.1484 27.5225C59.1484 28.0915 59.6097 28.5528 60.1788 28.5528H68.9698C69.5388 28.5528 70.0001 28.0915 70.0001 27.5225C70.0001 26.9535 69.5388 26.4922 68.9698 26.4922Z"
      fill="#254447"
    />
    <path
      d="M68.9698 33.9688H60.1788C59.6097 33.9688 59.1484 34.43 59.1484 34.9991C59.1484 35.5681 59.6097 36.0294 60.1788 36.0294H68.9698C69.5388 36.0294 70.0001 35.5681 70.0001 34.9991C70.0001 34.43 69.5388 33.9688 68.9698 33.9688Z"
      fill="#254447"
    />
    <path
      d="M68.9698 41.4473H60.1788C59.6097 41.4473 59.1484 41.9086 59.1484 42.4776C59.1484 43.0466 59.6097 43.5079 60.1788 43.5079H68.9698C69.5388 43.5079 70.0001 43.0466 70.0001 42.4776C70.0001 41.9086 69.5388 41.4473 68.9698 41.4473Z"
      fill="#254447"
    />
    <path
      d="M68.9698 48.9258H60.1788C59.6097 48.9258 59.1484 49.3871 59.1484 49.9561C59.1484 50.5251 59.6097 50.9864 60.1788 50.9864H68.9698C69.5388 50.9864 70.0001 50.5251 70.0001 49.9561C70.0001 49.3871 69.5388 48.9258 68.9698 48.9258Z"
      fill="#254447"
    />
    <path
      d="M9.82133 19.0137H1.03031C0.461289 19.0137 0 19.475 0 20.044C0 20.613 0.461289 21.0743 1.03031 21.0743H9.82133C10.3904 21.0743 10.8516 20.613 10.8516 20.044C10.8516 19.475 10.3904 19.0137 9.82133 19.0137Z"
      fill="#254447"
    />
    <path
      d="M9.82133 26.4922H1.03031C0.461289 26.4922 0 26.9535 0 27.5225C0 28.0915 0.461289 28.5528 1.03031 28.5528H9.82133C10.3904 28.5528 10.8516 28.0915 10.8516 27.5225C10.8516 26.9535 10.3904 26.4922 9.82133 26.4922Z"
      fill="#254447"
    />
    <path
      d="M9.82133 33.9688H1.03031C0.461289 33.9688 0 34.43 0 34.9991C0 35.5681 0.461289 36.0294 1.03031 36.0294H9.82133C10.3904 36.0294 10.8516 35.5681 10.8516 34.9991C10.8516 34.43 10.3904 33.9688 9.82133 33.9688Z"
      fill="#254447"
    />
    <path
      d="M9.82133 41.4473H1.03031C0.461289 41.4473 0 41.9086 0 42.4776C0 43.0466 0.461289 43.5079 1.03031 43.5079H9.82133C10.3904 43.5079 10.8516 43.0466 10.8516 42.4776C10.8516 41.9086 10.3904 41.4473 9.82133 41.4473Z"
      fill="#254447"
    />
    <path
      d="M9.82133 48.9258H1.03031C0.461289 48.9258 0 49.3871 0 49.9561C0 50.5251 0.461289 50.9864 1.03031 50.9864H9.82133C10.3904 50.9864 10.8516 50.5251 10.8516 49.9561C10.8516 49.3871 10.3904 48.9258 9.82133 48.9258Z"
      fill="#254447"
    />
    <path
      d="M61.0648 12.3546V57.2202C61.0648 59.226 59.4387 60.8521 57.4329 60.8521H12.5672C10.5614 60.8521 8.9353 59.226 8.9353 57.2202V12.3546C8.9353 10.3488 10.5614 8.72266 12.5672 8.72266H57.4329C59.4387 8.72266 61.0648 10.3485 61.0648 12.3546Z"
      fill="#466568"
    />
    <path
      d="M57.7861 15.3899V54.6119C57.7861 56.3654 56.3645 57.7869 54.611 57.7869H15.3889C13.6353 57.7869 12.2139 56.3653 12.2139 54.6119V15.3899C12.2139 13.6363 13.6355 12.2148 15.3889 12.2148H54.6109C56.3645 12.2148 57.7861 13.6364 57.7861 15.3899Z"
      fill="#254447"
    />
    <path
      d="M51.2366 20.8114V48.7607C51.2366 50.0095 50.2242 51.0232 48.974 51.0232H21.026C19.7758 51.0232 18.7634 50.0093 18.7634 48.7607V20.8114C18.7634 19.5612 19.7758 18.5488 21.026 18.5488H48.9739C50.2241 18.5488 51.2366 19.5612 51.2366 20.8114Z"
      fill="#BFDEE1"
    />
    <path
      d="M51.2366 20.8114V48.7607C51.2366 50.0095 50.2242 51.0232 48.9741 51.0232H24.5292C23.279 51.0232 22.2666 50.0093 22.2666 48.7607V20.8114C22.2666 19.5612 23.279 18.5488 24.5292 18.5488H48.9739C50.2241 18.5488 51.2366 19.5612 51.2366 20.8114Z"
      fill="#D6F5F8"
    />
    <path
      d="M27.4149 23.7148H18.7629V25.7755H27.4149V23.7148Z"
      fill="#AAC9CC"
    />
    <path
      d="M44.3988 18.5488H42.3381V34.8622H44.3988V18.5488Z"
      fill="#AAC9CC"
    />
    <path
      d="M27.4478 43.6523H25.3872V51.0239H27.4478V43.6523Z"
      fill="#AAC9CC"
    />
    <path
      d="M51.2368 43.4771V45.5377H36.1377V51.0231H34.0771V36.1371H29.979C29.4103 36.1371 28.9487 35.6755 28.9487 35.1067V27.4151C28.9487 26.8463 29.4103 26.3848 29.979 26.3848C30.5492 26.3848 31.0094 26.8463 31.0094 27.4151V34.0764H39.8069C40.3757 34.0764 40.8372 34.538 40.8372 35.1067C40.8372 35.6755 40.3757 36.1371 39.8069 36.1371H36.1377V43.4771H51.2368Z"
      fill="#AAC9CC"
    />
    <path
      d="M33.3981 24.744C33.3981 26.0835 32.5752 27.2319 31.4075 27.71C31.0325 27.8638 30.6231 27.949 30.193 27.949C28.4222 27.949 26.988 26.5134 26.988 24.744C26.988 22.9746 28.4222 21.5391 30.193 21.5391C30.623 21.5391 31.0323 21.6242 31.4075 21.778C32.5752 22.2562 33.3981 23.4046 33.3981 24.744Z"
      fill="#223234"
    />
    <path
      d="M29.4101 41.9419C29.4101 43.1618 28.6805 44.2113 27.6324 44.6771C27.2615 44.842 26.8508 44.934 26.418 44.934C24.7667 44.934 23.4272 43.5946 23.4272 41.9419C23.4272 40.2906 24.7667 38.9512 26.418 38.9512C26.8507 38.9512 27.2615 39.0432 27.6324 39.2081C28.6807 39.6739 29.4101 40.7235 29.4101 41.9419Z"
      fill="#223234"
    />
    <path
      d="M47.2141 35.1063C47.2141 36.8058 46.1109 38.2481 44.582 38.7551C44.2015 38.8828 43.7934 38.9516 43.369 38.9516C41.2453 38.9516 39.5225 37.2303 39.5225 35.1063C39.5225 32.9824 41.2451 31.2598 43.369 31.2598C43.7936 31.2598 44.2015 31.3284 44.582 31.4562C46.1109 31.9632 47.2141 33.4069 47.2141 35.1063Z"
      fill="#223234"
    />
    <path
      d="M33.3984 24.7453C33.3984 26.0847 32.5755 27.2331 31.4078 27.7113C30.2387 27.2345 29.4158 26.0847 29.4158 24.7453C29.4158 23.4058 30.2387 22.256 31.4078 21.7793C32.5755 22.2574 33.3984 23.4058 33.3984 24.7453Z"
      fill="#315053"
    />
    <path
      d="M29.4102 41.9428C29.4102 43.1628 28.6807 44.2122 27.6326 44.678C26.5857 44.2123 25.855 43.1628 25.855 41.9428C25.855 40.7229 26.5859 39.6748 27.6326 39.209C28.6808 39.6748 29.4102 40.7244 29.4102 41.9428Z"
      fill="#315053"
    />
    <path
      d="M47.2142 35.1071C47.2142 36.8066 46.111 38.2489 44.5821 38.7559C43.053 38.2489 41.95 36.8066 41.95 35.1071C41.95 33.4077 43.0531 31.964 44.5821 31.457C46.111 31.964 47.2142 33.4077 47.2142 35.1071Z"
      fill="#315053"
    />
  </svg>
)
